export default __webpack_public_path__ + "no-results-found-gray.671a8e1f08ea8ad028b41d848d1b4df0.svg";